import React from 'react'
import listMocked from '../../../../common/services/mock/suscripcione.json'
import { CGE } from '../../../../common/components/CGE'
import SubscriptionsContextProvider, { ACTIONS, SubscriptionsContext } from '../../context/SubscriptionsContextProvider';
import arTitles from "../../../../common/services/mock/title.json";
import { getPathName, splitArray } from '../../../../common/utils/utilsFunc';
import ClayTable from "@clayui/table";
import Pagination from '../../../../common/components/Pagination';
import HeaderSearch from "../../../../common/components/HeaderSearch";
import Loading from "../../../../common/components/Loading";

function ListSubscriptions({ props, qtdRowPage }) {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [newArrTitle, setNewArrTitle] = React.useState(null);
    const [data, setData] = React.useState([]);
    const [arrayListId, setArrayListId] = React.useState();
    const [indexId, setIndexId] = React.useState(0);
    const [listSubscriptions, setListSubscriptions] = React.useState(null);
    const [dataTable, setDataTable] = React.useState([]);
    const [state, dispatch] = React.useContext(SubscriptionsContext)
    const [inputSearch, setInputSearch] = React.useState("");
    const [inputSelected, setInputSelected] = React.useState("");
    const [activePage, setActivePage] = React.useState(1);
    const [rowPage, setRowPageList] = React.useState(10);
    const [currentArray, setCurrentArray] = React.useState([]);

    function setRowPage(nPage) {
        setActivePage(1);
        setRowPageList(Number(nPage));
    }

    var panelFooter = <>
       { dataTable?.length > 0 && <div className="d-flex align-items-center justify-content-center flex-column-reverse ">
            <Pagination
                items={dataTable}
                onChangePage={setActivePage}
                qtdRowPage={qtdRowPage}
                setRowPage={setRowPage}
                pageSize={rowPage}
                currentPg={activePage}
            />
        </div>}
    </>

    React.useEffect(() => {
        if (inputSearch) {
            if (data.find((data) => data.toString() === inputSearch)) {
                setInputSelected(inputSearch);
                document.getElementById("mySelectId").value = inputSearch;
            } else {
                setInputSelected("");
                document.getElementById("mySelectId").value = "";
            }
        }
    }, [inputSearch]);

    React.useEffect(() => {

        if (inputSelected) {
            setInputSearch("");
        }

    }, [inputSelected]);

    React.useEffect(() => {
        let arrayOfarrays = [];
        let filterArray = [];
    
        if (inputSearch) {
          filterArray = dataTable.filter(function (obj) {
            return obj.CuentaContrato.toString().includes(inputSearch);
          });
          setListSubscriptions(filterArray);
        } else if (inputSelected) {
    
          filterArray = dataTable.filter(function (obj) {
            return obj.CuentaContrato.toString() === inputSelected;
          });
          setListSubscriptions(filterArray);
        }
    
        if(!inputSelected && !inputSearch) {
          arrayOfarrays = splitArray(dataTable, rowPage);
          setCurrentArray(arrayOfarrays[activePage - 1]);
        } else if(dataTable?.length === 0){
          props.setGlobalAlert(props.text_fetch_error,"warning", true, "Advertencia");
        }else{
          arrayOfarrays = splitArray(filterArray, rowPage);
          setCurrentArray(arrayOfarrays[activePage - 1]);
        }
    
      },[inputSearch,inputSelected,activePage, dataTable]);

    React.useEffect(() => {
        setNewArrTitle(arTitles[getPathName()]?.map(item => item.label));
    }, [getPathName()])

    React.useEffect(() => {
        setLoading(true);
    }, []);



    React.useEffect(() => {
        if (state.listSuscripciones) {
            
            setLoading(false);

            const objResponse = state.listSuscripciones;

            if(objResponse?.response?.status === 200) {


                let newListMocked = objResponse?.data?.item;
                newListMocked = [...newListMocked, newListMocked.map(obj => {
                    
                    let string = '-'
                    if (obj.CorreoElectronicoTitular) {
                        string = "Correo Titular: "+obj.CorreoElectronicoTitular
                        if (obj.CorreoElectronicoSecundario) {
                            string += "\r\nCorreo Secundario:" + obj.CorreoElectronicoSecundario
                        }
                    } else if (obj.CorreoElectronicoSecundario) {
                        string = "Correo Secundario:" +obj.CorreoElectronicoSecundario
                    }
                    obj.email = string;
                    obj.opciones = !obj.CorreoElectronicoTitular && !obj.CorreoElectronicoSecundario && !obj.TipoRelacionInmueble ? "Suscripción Electrónica" : "Modificar y Anular";
                    delete obj.CorreoElectronicoSecundario;
                    delete obj.CorreoElectronicoTitular;
                })]
                
                newListMocked.splice((newListMocked.length - 1), 1);
                setDataTable(newListMocked)
                
            }
        }
    }, [state.listSuscripciones]);

    React.useEffect(() => {
        if (state.idList) {
            setData(state.idList)
        }
    }, [state.idList]);

    function handleClickButtonSubscription(cuentaContrato) {
        window.location.href = `/group/guest/alta-de-suscripcion?ctacto=${cuentaContrato}`
    }

    function handleClickButtonSubscriptionWithoutId() {
        window.location.href = `/group/guest/alta-de-suscripcion`
    }

    function handleClickButtonModification(cuentaContrato) {
        window.location.href = `/group/guest/modificacion-suscripcion?ctacto=${cuentaContrato}`

    }

    function handleClickButtonAnulation(cuentaContrato) {
        window.location.href = `/group/guest/anulacion-de-suscripcion?ctacto=${cuentaContrato}`
    }

    return (
        <>
            <HeaderSearch
                data={data}
                setSearch={setInputSearch}
                setSelected={setInputSelected}
                idClient={inputSelected}
                inputSearch={inputSearch}
            />
            <CGE.Panel
                title={props.title_subscription}
                footerContent={panelFooter}
            >
                <div className="container-table">
                    <ClayTable
                        className="table table-striped table-autofit show-quick-actions-on-hover table-list
                        table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
                        id="table-to-xls"
                    >
                        <ClayTable.Head>
                            <ClayTable.Row>
                                {newArrTitle?.map((title) => {
                                    return (
                                        <ClayTable.Cell
                                            className="clientCell font-weight-bold"
                                            headingCell
                                        >
                                            {title}
                                        </ClayTable.Cell>
                                    );
                                })}
                            </ClayTable.Row>
                        </ClayTable.Head>
                        <ClayTable.Body>
                            {currentArray?.map((obj) => {
                                return (
                                    <ClayTable.Row className="tableRow">
                                        {Object.keys(obj).map((index) => {
                                            return (
                                                <ClayTable.Cell
                                                    className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                                                    title={index === "email" && obj[index].replace("-")?obj[index]:""}
                                                    style={{ whiteSpace: 'pre-wrap' }}
                                                >
                                                    {index === "TipoRelacionInmueble" ? (
                                                        !obj.CorreoElectronicoTitular && !obj.CorreoElectronicoSecundario && !obj.TipoRelacionInmueble ?
                                                            <CGE.Text text="Papel" className="color-orange" /> :
                                                            <CGE.Text text="Electrónico" className="color-green" />
                                                    ) :
                                                        index === "opciones" ? (
                                                            obj["opciones"] === "Suscripción Electrónica" ?
                                                                <div>
                                                                    <a
                                                                        title="Alta Suscripción"
                                                                        onClick={() => handleClickButtonSubscription(obj["CuentaContrato"])}
                                                                    >
                                                                        <CGE.Icon style={{ fontSize: "40px" }} name="computer" />
                                                                    </a>
                                                                </div>
                                                                :
                                                                <div className="d-flex align-items-center">
                                                                    <a
                                                                        title="Modificar Suscripción"
                                                                        onClick={() => handleClickButtonModification(obj["CuentaContrato"])}
                                                                    >
                                                                        <div className="mr-3">
                                                                            <CGE.Icon style={{ fontSize: "40px" }} name="document" />
                                                                        </div>
                                                                    </a>
                                                                    <a
                                                                    title="Anular Suscripción"
                                                                        onClick={() => handleClickButtonAnulation(obj["CuentaContrato"])}
                                                                    >
                                                                        <CGE.Icon style={{ fontSize: "40px" }} name="trash" />
                                                                    </a>
                                                                </div>
                                                        ) :
                                                        index === "email" ? (
                                                            <CGE.Text text={obj[index]?.replaceAll("Correo Secundario:","")?.replaceAll("Correo Titular:","")?.replaceAll(" ","")} />
                                                                
                                                            ):obj[index]}
                                                </ClayTable.Cell>
                                            );
                                        })}
                                    </ClayTable.Row>
                                );
                            })}
                            {!currentArray && !loading && 
                                <ClayTable.Row className="tableRow">
                                                <ClayTable.Cell colspan="5">No se han encontrado N° de Clientes asociados</ClayTable.Cell>
                                </ClayTable.Row>
                                }
                        </ClayTable.Body>
                    </ClayTable>

                </div>

            </CGE.Panel>
            {loading &&
                <Loading />
            }               
        </>
    )
}

const ListSubscriptionsWithProvider = ({
    props,
    qtdRowPage

}) => (
    <SubscriptionsContextProvider>
        <ListSubscriptions
            props={props}
            qtdRowPage={qtdRowPage}
        />
    </SubscriptionsContextProvider>
);

export default ListSubscriptionsWithProvider;